const state = {
  user: null,
  program: null,
  term: null,
  txScope: null,
  tx: null,
  expansionIndex: 0,
  panelName: 'logon',
  resetIndex: Math.random() * -1,
  initialized: false,
};

const mutations = {
  setUser(state, value) {
    state.user = value;
  },
  setProgram(state, value) {
    state.program = value;
  },
  setTerm(state, value) {
    state.term = value;
  },
  setTxScope(state, value) {
    state.txScope = value;
  },
  setTx(state, value) {
    state.tx = value;
  },
  setExpansionIndex(state, value) {
    state.expansionIndex = value;
  },
  setPanelName(state, value) {
    state.panelName = value;
  },
  setResetIndex(state, value) {
    state.resetIndex = value;
  },
  setInitialized(state, value) {
    state.initialized = value;
  },
  resetStore(state) {
    state.user = null;
    state.program = null;
    state.txScope = null;
    state.tx = null;
    state.expansionIndex = 0;
    state.resetIndex = Math.random() * -1;
  },
};

const actions = {
  setUser({ commit }, value) {
    commit('setUser', value);
  },
  setProgram({ commit }, value) {
    commit('setProgram', value);
  },
  setTerm({ commit }, value) {
    commit('setTerm', value);
  },
  setTxScope({ commit }, value) {
    commit('setTxScope', value);
  },
  setTx({ commit }, value) {
    commit('setTx', value);
  },
  setExpansionIndex({ commit }, value) {
    commit('setExpansionIndex', value);
  },
  setPanelName({ commit }, value) {
    commit('setPanelName', value);
  },
  setResetIndex({ commit }, value) {
    commit('setResetIndex', value);
  },
  setInitialized({ commit }, value) {
    commit('setInitialized', value);
  },
  resetStore({ commit }) {
    commit('resetStore');
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
